"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSensitization = createSensitization;
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const messages = {
    sensitization: {
        id: "dashboard.sensitization",
        defaultMessage: "Szenzitizációs státusz"
    },
    praCdc: {
        id: "dashboard.pra_cdc",
        defaultMessage: "PRA CDC"
    },
    praLuminex: {
        id: "dashboard.pra_luminex",
        defaultMessage: "PRA Luminex"
    },
    transplantImmunConcilium: {
        id: "dashboard.transplant_immun_concilium",
        defaultMessage: "Követési stratégia, kontroll javaslat"
    }
};
function createSensitization(intl, options) {
    const praCdc = createPraCdc(intl, options);
    const praLuminex = createPraLuminex(intl, options);
    const transplantImmunConcilium = createTransplantImmunConcilium(intl, options);
    const content = (0, shared_1.createSectionContent)([
        praCdc,
        praLuminex,
        transplantImmunConcilium
    ]);
    return (0, shared_1.createSection)(intl, { label: messages.sensitization, content });
}
function createPraCdc(intl, { events }) {
    return (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.praCdc,
        query: queries_1.queries.praCdc
    });
}
function createPraLuminex(intl, { events }) {
    return (0, shared_1.createNumberRecord)(intl, {
        events,
        label: messages.praLuminex,
        query: queries_1.queries.praLuminex
    });
}
function createTransplantImmunConcilium(intl, { events }) {
    return (0, shared_1.createStringRecord)(intl, {
        events,
        variant: "long",
        label: messages.transplantImmunConcilium,
        query: queries_1.queries.transplantImmunConcilium
    });
}
